@if (pwaInstall.shouldShowBanner()) {
  <div
    class="pwa-install-banner"
    role="region"
    aria-label="Install application"
    animate.enter="pwa-install-banner--enter"
    animate.leave="pwa-install-banner--leave"
  >
    <div class="pwa-install-banner__content">
      <mat-icon>install_mobile</mat-icon>
      @if (pwaInstall.manualInstallHint(); as hint) {
        <span>{{ hint }}</span>
      } @else {
        <span>Install Master Schedule for quick access from your home screen.</span>
      }
    </div>
    <div class="pwa-install-banner__actions">
      @if (pwaInstall.manualInstallHint()) {
        <button mat-button type="button" (click)="dismiss()">Got it</button>
      } @else {
        <button mat-button type="button" (click)="dismiss()">Not now</button>
        <button
          mat-flat-button
          type="button"
          [disabled]="!pwaInstall.canInstall()"
          (click)="install()"
        >
          Install
        </button>
      }
    </div>
  </div>
}
